/** Server-side contact take limits for the share-room directory GET. */
export const SHARE_ROOM_CONTACT_TAKE = {
  unfiltered: 400,
  search: 50,
  communityFilter: 200,
} as const

export type ShareRoomContactTakeKind = keyof typeof SHARE_ROOM_CONTACT_TAKE

export type ShareRoomDirectoryEnvelope<T = unknown> = {
  items: T[]
  truncated: boolean
  limit: number
}

export const EMPTY_SHARE_ROOM_DIRECTORY: ShareRoomDirectoryEnvelope = {
  items: [],
  truncated: false,
  limit: 0,
}

export function shareRoomContactTakeLimit(kind: ShareRoomContactTakeKind): number {
  return SHARE_ROOM_CONTACT_TAKE[kind]
}

/** `findMany` with take limit+1, then slice — truncated is true when a row was dropped. */
export function sliceWithTruncation<T>(
  rows: T[],
  limit: number
): { items: T[]; truncated: boolean } {
  if (limit <= 0) {
    return { items: [], truncated: false }
  }
  const truncated = rows.length > limit
  return {
    items: truncated ? rows.slice(0, limit) : rows,
    truncated,
  }
}

export function shareRoomDirectoryJson<T>(
  items: T[],
  truncated: boolean,
  limit: number
): ShareRoomDirectoryEnvelope<T> {
  return { items, truncated, limit }
}

export function parseShareRoomDirectoryResponse(data: unknown): ShareRoomDirectoryEnvelope {
  if (Array.isArray(data)) {
    return { items: data, truncated: false, limit: 0 }
  }
  if (!data || typeof data !== 'object') {
    return { ...EMPTY_SHARE_ROOM_DIRECTORY }
  }
  const rec = data as Record<string, unknown>
  if (!Array.isArray(rec.items)) {
    return { ...EMPTY_SHARE_ROOM_DIRECTORY }
  }
  const limit =
    typeof rec.limit === 'number' && Number.isFinite(rec.limit) ? rec.limit : 0
  return {
    items: rec.items,
    truncated: rec.truncated === true,
    limit,
  }
}
